interface ConversationRow {
  id: string;
  parentId?: string | null;
  conversationRootId?: string | null;
}

/** Keep the first (server-sorted) matching message, even when the connecting Sent row is absent. */
export function collapseMessageConversations<T extends ConversationRow>(rows: T[]): T[] {
  const byId = new Map(rows.map(row => [row.id, row]));
  const roots = new Set<string>();
  return rows.filter(row => {
    let current = row;
    const visited = new Set<string>();
    while (!current.conversationRootId && current.parentId && byId.has(current.parentId) && !visited.has(current.id)) {
      visited.add(current.id);
      current = byId.get(current.parentId)!;
    }
    const root = current.conversationRootId || current.id;
    if (roots.has(root)) return false;
    roots.add(root);
    return true;
  });
}
